export { default } from './ProductPriceAvailabilityTable'
